module.exports = __webpack_public_path__ + "static/media/3_2.97878c12.png";